// Type-safe GA4 tracking utility
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const MILESTONES = [10, 50, 100, 500];
let trackedMilestones = new Set<number>();

export const Analytics = {
  trackEvent(eventName: string, params: Record<string, unknown> = {}) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, params);
    }
  },

  gameStart(playerName: string, gameMode: 'single' | 'multi') {
    this.trackEvent('game_start', { player_name: playerName, game_mode: gameMode });
    trackedMilestones.clear(); // Reset milestones for new game
  },

  gameDeath(score: number, killerType: 'ai' | 'boundary' | 'self') {
    this.trackEvent('game_death', { score, killer_type: killerType });
  },

  checkScoreMilestone(score: number) {
    for (const milestone of MILESTONES) {
      if (score >= milestone && !trackedMilestones.has(milestone)) {
        trackedMilestones.add(milestone);
        this.trackEvent('score_milestone', { milestone, current_score: score });
      }
    }
  },

  boostUsed(currentScore: number) {
    this.trackEvent('boost_used', { current_score: currentScore });
  },

  cometCatch(currentScore: number, cometValue: number) {
    this.trackEvent('comet_catch', { current_score: currentScore, comet_value: cometValue });
  },

  shareScore(score: number, method: 'clipboard' | 'twitter') {
    this.trackEvent('share_score', { score, share_method: method });
  },

  resetMilestones() {
    trackedMilestones.clear();
  }
};
